const productBadgeFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/product-badge-empty.svg";
const supplierBadgeFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/supplier-badge-empty.svg";
const productHeroFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/product-hero-empty.svg";
const supplierHeroFallback =
  "https://storage.googleapis.com/sellar-partner-images/sellar-image-assets/app-assets/supplier-hero-empty.svg";

export type ImageFallbackType =
  | "product-badge"
  | "product-hero"
  | "supplier-badge"
  | "supplier-hero";

export const setFallbackImage = ({
  img,
  fallback,
}: {
  img: string | null | undefined;
  fallback?: ImageFallbackType;
}) => {
  if (img || !fallback) return img;

  switch (fallback) {
    case "product-badge":
      return productBadgeFallback;
    case "product-hero":
      return productHeroFallback;
    case "supplier-badge":
      return supplierBadgeFallback;
    case "supplier-hero":
      return supplierHeroFallback;
    default:
      return productBadgeFallback;
  }
};
